import './app.css';

import {analyticsEvent} from './js/viscom/viscomjs/analytics/analyticsEvent';

/* is production */
const isProd = process.env.NODE_ENV === 'production';

analyticsEvent('Page', 'load', 'Success');

/* service worker */
if ('serviceWorker' in navigator && isProd) {
    import(/* webpackPrefetch: true */ './js/sw').then(func => {
        func.default();
    });
}

/* lazy loading (https://github.com/verlok/lazyload) */
if (document.querySelector('.lazy') !== null) {
    import(/* webpackPrefetch: true */ './js/lazyloading').then(func => {
        func.default();
    });
}

(function() {
    //
    import(/* webpackPrefetch: true */ './js/viscom/12moments/app/App').then(func => {
        const app = func.default();
        app.start();
    });
    //
})();
